import { render } from "./ProjectHome.vue?vue&type=template&id=24a129d2&scoped=true"
const script = {}

import "./ProjectHome.vue?vue&type=style&index=0&id=24a129d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24a129d2"

export default script